import { gql } from '@apollo/client';
// local imports
import { API_ADMIN_EMPLOYEE_RESET_CONFIRMED_SKILLS } from '../config/api';

export const RESET_CONFIRMED_SKILLS = gql`
  mutation ResetConfirmedSkills(
    $employee_id: Int!
    $input: JSON
  ) {
    resetConfirmedSkills(
      employee_id: $employee_id,
      input: $input
    )
    @rest(
      type: "MutationResponse",
      path: "${API_ADMIN_EMPLOYEE_RESET_CONFIRMED_SKILLS}",
      method: "POST"
    ) {
      success
    }
  }
`;
